import { render } from "./closedProcesses.vue?vue&type=template&id=1e684804"
import script from "./closedProcesses.vue?vue&type=script&lang=js"
export * from "./closedProcesses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__